'use es6';

import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { Component } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { debounce } from 'underscore';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getDomReadyBlockingResource, getFailedInpageAssets, getInpageJsLoadedMultipleTimes } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBreakString from 'UIComponents/text/UIBreakString';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const mapStateToProps = state => ({
  contentModelId: getContentModelId(state),
  failedInpageAssets: getFailedInpageAssets(state),
  inpageJsLoadedMultipleTimes: getInpageJsLoadedMultipleTimes(state),
  domReadyBlockingResource: getDomReadyBlockingResource(state)
});

// Temporary component to get a handle on how many customers have pages that seemingly have
// "critical failures" before figuring out how/where to show errors in the UI
class TrackCriticalAssetFailuresWithRaven extends Component {
  constructor(props) {
    super(props);
    this.showSlowResourceWarning = () => {
      const {
        domReadyBlockingResource
      } = this.props;
      FloatingAlertStore.addAlert({
        titleText: I18n.text('app.errors.default-error.domReadyBlockingResource.default.title'),
        message: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.errors.default-error.domReadyBlockingResource.default.message"
          }), /*#__PURE__*/_jsxs(UIList, {
            styled: true,
            children: [domReadyBlockingResource.js && /*#__PURE__*/_jsx(UIBreakString, {
              children: domReadyBlockingResource.js.url
            }), domReadyBlockingResource.css && /*#__PURE__*/_jsx(UIBreakString, {
              children: domReadyBlockingResource.css.url
            })]
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.errors.default-error.domReadyBlockingResource.default.message2"
          })]
        }),
        type: 'warning',
        sticky: true
      });
    };
    this.logCriticalFailuresWithRaven = debounce(this.logCriticalFailuresWithRaven, 3000);
  }
  componentDidMount() {
    const {
      contentModelId,
      failedInpageAssets,
      inpageJsLoadedMultipleTimes
    } = this.props;
    if (failedInpageAssets.size > 0) {
      this.logCriticalFailuresWithRaven();
    }
    if (inpageJsLoadedMultipleTimes) {
      this.logMultipleInpageJSWithRaven(contentModelId);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      contentModelId,
      failedInpageAssets,
      inpageJsLoadedMultipleTimes,
      domReadyBlockingResource
    } = this.props;
    if (prevProps.failedInpageAssets !== failedInpageAssets && failedInpageAssets.size > 0) {
      this.logCriticalFailuresWithRaven();
    }
    if (inpageJsLoadedMultipleTimes) {
      this.logMultipleInpageJSWithRaven(contentModelId);
    }
    if (domReadyBlockingResource && domReadyBlockingResource !== prevProps.domReadyBlockingResource) {
      this.showSlowResourceWarning();
    }
  }

  // Send a page event to LogFetch for failed inpage assets (once per editor session)
  // https://private.hubteam.com/logfetch/search?serviceIds=ERRORS.PAGE_EVENTS&searchFilters=event_key:EQUAL:critical-inpage-editor-assets-failed&environment=prod&logType=CUSTOM_LOGFETCH_EVENT
  logCriticalFailuresWithRaven() {
    const {
      contentModelId,
      failedInpageAssets
    } = this.props;
    if (this.alreadyLoggedCriticalFailuresWithRavenOnce) {
      return;
    }
    this.alreadyLoggedCriticalFailuresWithRavenOnce = true;
    const failedAssetsString = failedInpageAssets.toArray().toString();
    Raven.capturePageEvent('critical-inpage-editor-assets-failed', {
      extra: {
        contentId: contentModelId,
        failedAssets: failedAssetsString,
        numFailedAssets: failedInpageAssets.size
      }
    });
  }
  logMultipleInpageJSWithRaven(contentModelId) {
    if (this.alreadyLoggedMultipleInpageWithRavenOnce) {
      return;
    }
    this.alreadyLoggedMultipleInpageWithRavenOnce = true;
    Raven.capturePageEvent('inpage-editor-js-run-multiple-times', {
      extra: {
        contentId: contentModelId
      }
    });
  }
  render() {
    return null;
  }
}
TrackCriticalAssetFailuresWithRaven.propTypes = {
  contentModelId: PropTypes.number.isRequired,
  failedInpageAssets: PropTypes.instanceOf(List),
  inpageJsLoadedMultipleTimes: PropTypes.bool.isRequired,
  domReadyBlockingResource: PropTypes.string
};
export default connect(mapStateToProps)(TrackCriticalAssetFailuresWithRaven);